/**
 * Cart Event Tracking
 *
 * Tracks cart interactions (subscription switches, cross-sells) to Google Analytics 4.
 * Captures user/session info and cart context for analysis.
 */

(function () {
  'use strict';

  var SESSION_ID_KEY = 'pemmican_session_id';

  /**
   * Generate a simple unique session ID
   */
  function generateSessionId() {
    return 'sess_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
  }

  /**
   * Get or create session ID (persists for browser session)
   */
  function getSessionId() {
    var sessionId = sessionStorage.getItem(SESSION_ID_KEY);
    if (!sessionId) {
      sessionId = generateSessionId();
      sessionStorage.setItem(SESSION_ID_KEY, sessionId);
    }
    return sessionId;
  }

  /**
   * Get customer ID if logged in (from Shopify's customer object)
   */
  function getCustomerId() {
    // Shopify exposes customer info on window if logged in
    if (window.__st && window.__st.cid) {
      return window.__st.cid;
    }
    return null;
  }

  /**
   * Get cart token from cookie
   */
  function getCartToken() {
    var match = document.cookie.match(/cart=([^;]+)/);
    return match ? match[1] : null;
  }

  /**
   * Send event to Google Analytics 4
   */
  function sendGA4Event(eventName, eventParams) {
    if (typeof gtag !== 'function') {
      console.warn('Cart tracking: gtag not available');
      return;
    }

    gtag('event', eventName, eventParams);
  }

  /**
   * Track subscription switch event
   *
   * @param {Object} data - Event data
   * @param {string} data.variantId - The variant ID being switched
   * @param {string} data.productTitle - Product title
   * @param {string} data.productHandle - Product handle
   * @param {number} data.quantity - Quantity being switched
   * @param {string} data.sellingPlanId - The subscription plan ID
   * @param {string} data.type - 'single' or 'all' (switch one item vs switch all)
   */
  function trackSubscriptionSwitch(data) {
    var eventParams = {
      event_category: 'cart',
      event_label: data.productTitle || data.productHandle || 'unknown',
      variant_id: data.variantId,
      product_handle: data.productHandle,
      quantity: data.quantity || 1,
      selling_plan_id: data.sellingPlanId,
      switch_type: data.type || 'single',
      cart_token: getCartToken(),
      customer_id: getCustomerId(),
      session_id: getSessionId(),
    };

    sendGA4Event('subscription_switch', eventParams);

    console.log('Cart tracking: subscription_switch', eventParams);
  }

  /**
   * Track cross-sell click event
   *
   * @param {Object} data - Event data
   * @param {string} data.variantId - The variant ID being added
   * @param {string} data.productTitle - Product title
   * @param {string} data.productHandle - Product handle
   * @param {string} data.discountCode - Discount code applied (if any)
   */
  function trackCrossSellClick(data) {
    var eventParams = {
      event_category: 'cart',
      event_label: data.productTitle || data.productHandle || 'unknown',
      variant_id: data.variantId,
      product_handle: data.productHandle,
      discount_code: data.discountCode || '',
      cart_token: getCartToken(),
      customer_id: getCustomerId(),
      session_id: getSessionId(),
    };

    sendGA4Event('cross_sell_click', eventParams);

    console.log('Cart tracking: cross_sell_click', eventParams);
  }

  // Expose tracking functions globally
  window.CartTracking = {
    trackSubscriptionSwitch: trackSubscriptionSwitch,
    trackCrossSellClick: trackCrossSellClick,
    getSessionId: getSessionId,
    getCustomerId: getCustomerId,
    getCartToken: getCartToken,
  };
})();
